import useDocumentTitle from "../../Common/useDocumentTitle";
import DashboardContent from "./DashboardContent/dashboardContent";

/**
 * Returns the Admin Dashboard page component.
 * 
 * @returns The Admin Dashboard page component.
 */
const AdminDashboard = () => {
    useDocumentTitle("Admin Dashboard");
    return (
        <>
            <div className="flex flex-col h-fit md:h-screen">
                <DashboardContent />
            </div>
        </>
    );
};
 
export default AdminDashboard;